import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaitomahabaleshwarcab() {



const cardData = {
  keyword: " Navi Mumbai to Mahabaleshwar Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Navi Mumbai to Mahabaleshwar cab services for travelers planning a refreshing hill station getaway in the beautiful Sahyadri mountains. Mahabaleshwar is one of the most popular hill stations in Maharashtra, known for its cool climate, scenic viewpoints, strawberry farms, waterfalls, and lush green valleys. Whether you are planning a family vacation, romantic trip, weekend getaway, or group outing, our cab service ensures a smooth and enjoyable journey with experienced drivers and well-maintained vehicles. The distance from Navi Mumbai to Mahabaleshwar is approximately 240–260 km and the journey usually takes around 5 to 6 hours via the Mumbai–Pune Expressway and Wai route. We provide flexible booking options including one-way trips, round-trip packages, and multi-day travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from any location in Navi Mumbai, professional chauffeurs experienced in hill driving, and 24/7 customer support, Omshree Cab is your trusted partner for Navi Mumbai to Mahabaleshwar cab booking.",

topPlaces: [
  {
    title: "Venna Lake",
    description:
      "Venna Lake is one of the most famous tourist attractions in Mahabaleshwar and is known for its peaceful environment and scenic surroundings. Visitors can enjoy boating on the lake, horse riding along the lakeside paths, and tasting local street food sold near the entrance area. The calm water surrounded by green hills creates a relaxing atmosphere for families and couples. Many tourists visit this lake during sunset to enjoy the cool breeze and beautiful reflections on the water. Travelers arriving by cab from Navi Mumbai can comfortably spend time exploring the lakeside area and enjoying the relaxing hill station atmosphere."
  },
  {
    title: "Arthur’s Seat",
    description:
      "Arthur’s Seat is one of the most breathtaking viewpoints in Mahabaleshwar and offers stunning panoramic views of deep valleys and the Savitri River flowing far below. Often called the 'Queen of all viewpoints', this location attracts photographers, nature lovers, and adventure seekers. Visitors can enjoy walking along nearby viewpoints such as Echo Point and Tiger Spring while admiring the dramatic landscape of the Western Ghats. The cool mountain air and peaceful surroundings make it a perfect place to relax and take photographs. Traveling by cab from Navi Mumbai makes it easy for visitors to reach this scenic viewpoint comfortably."
  },
  {
    title: "Mapro Garden",
    description:
      "Mapro Garden is a popular tourist destination in Mahabaleshwar famous for its strawberry products, delicious food, and beautiful garden setting. Visitors often stop here to taste fresh strawberries with cream, fruit syrups, chocolates, sandwiches, and desserts prepared by the famous Mapro brand. The location also has a food court, chocolate factory store, and open garden areas where visitors can relax and enjoy the pleasant weather. During the strawberry season the garden becomes especially lively with tourists. Travelers visiting Mahabaleshwar by cab from Navi Mumbai often include Mapro Garden as a relaxing food and shopping stop during their trip."
  },
  {
    title: "Elephant’s Head Point",
    description:
      "Elephant’s Head Point is a unique rock formation that resembles the head and trunk of an elephant when viewed from a particular angle. The viewpoint offers spectacular views of deep valleys, lush forests, and distant mountain ranges. The cool breeze and peaceful environment make it a perfect spot for photography and short nature walks. Visitors often spend time admiring the natural rock formation and enjoying the scenic beauty of the surrounding hills. A cab journey from Navi Mumbai allows tourists to comfortably include this viewpoint in their Mahabaleshwar sightseeing itinerary."
  },
  {
    title: "Pratapgad Fort",
    description:
      "Pratapgad Fort is a historic hill fort located near Mahabaleshwar and holds great significance in Maratha history. The fort is famous for the historic battle between Chhatrapati Shivaji Maharaj and Afzal Khan. Visitors can explore the fort walls, ancient structures, temples, and viewpoints that overlook the surrounding mountains and valleys. The climb to the fort offers scenic views and a glimpse into the region’s historical heritage. Travelers visiting Mahabaleshwar by cab from Navi Mumbai can comfortably visit this historic fort and learn about its important role in Maharashtra’s history."
  },
  {
    title: "Lingmala Waterfall",
    description:
      "Lingmala Waterfall is one of the most beautiful natural attractions near Mahabaleshwar and is surrounded by dense forests and green hills. The waterfall becomes especially spectacular during the monsoon season when water flows strongly down the rocky cliffs. Visitors can enjoy short treks, scenic viewpoints, and photography opportunities while experiencing the refreshing natural environment. The peaceful surroundings and cool climate make it an ideal place to relax and enjoy nature. Traveling by cab from Navi Mumbai allows visitors to conveniently explore this picturesque waterfall."
  },
  {
    title: "Wilson Point",
    description:
      "Wilson Point is the highest point in Mahabaleshwar and is famous for its stunning sunrise views over the Sahyadri mountain range. Early in the morning visitors gather here to watch the sun rise above the hills while enjoying the cool fresh air. The viewpoint offers wide panoramic views of the surrounding forests, valleys, and distant mountains. Because of its elevation, the weather here remains pleasant throughout the year. A comfortable cab journey from Navi Mumbai allows travelers to reach the viewpoint early and enjoy this breathtaking natural spectacle."
  },
  {
    title: "Kate’s Point",
    description:
      "Kate’s Point is another famous viewpoint in Mahabaleshwar that offers beautiful views of the Dhom Dam and the surrounding valleys. The location is known for its cool breezes and wide panoramic landscapes that make it perfect for photography and sightseeing. Nearby attractions such as Echo Point and Needle Hole Point add to the experience for visitors exploring this area. Tourists often stop here to admire the vast scenery of the Western Ghats. Booking a cab from Navi Mumbai makes it easy to include Kate’s Point in a full Mahabaleshwar sightseeing trip."
  },
  {
    title: "Mahabaleshwar Temple",
    description:
      "Mahabaleshwar Temple is an ancient and sacred temple dedicated to Lord Shiva and is one of the most important religious sites in the region. The temple is known for its traditional stone architecture and spiritual atmosphere. Devotees visit throughout the year to offer prayers and seek blessings. The temple complex also includes smaller shrines and historic structures that reflect the cultural heritage of Mahabaleshwar. Travelers visiting by cab from Navi Mumbai can conveniently include this spiritual destination in their travel itinerary."
  },
  {
    title: "Panch Ganga Temple",
    description:
      "Panch Ganga Temple is a historic temple in Mahabaleshwar believed to be the origin point of five sacred rivers including Krishna, Koyna, Venna, Savitri, and Gayatri. The temple has great religious significance and attracts pilgrims from different parts of India. Visitors come here to witness the small water outlets representing the five rivers and to experience the peaceful spiritual environment. The ancient architecture and cultural importance make it an interesting place for both pilgrims and tourists. A cab journey from Navi Mumbai allows travelers to easily visit this sacred temple while exploring Mahabaleshwar."
  }
],



services: [
{
name: "Navi Mumbai to Mahabaleshwar Cab",
description: "Navi Mumbai to Mahabaleshwar cab service provides comfortable and reliable transportation for travelers visiting the beautiful hill station of Mahabaleshwar from Navi Mumbai. The route passes through scenic highways and mountain roads offering a refreshing travel experience. Our fleet includes AC sedans, SUVs, and spacious MPV vehicles suitable for long-distance travel. Professional drivers ensure safe driving through ghat sections and highways. Pickup is available from homes, offices, hotels, railway stations, and Navi Mumbai airport areas. Comfortable seating and luggage space ensure relaxed travel for families and groups. Ideal for weekend trips, holiday travel, and tourism journeys."
},
{
name: "Navi Mumbai to Mahabaleshwar Taxi",
description: "Navi Mumbai to Mahabaleshwar taxi service offers dependable transportation for tourists and families traveling to the famous hill station. Vehicles provide smooth highway performance and comfortable seating suitable for long-distance travel. Professional drivers ensure safe driving through the expressway and mountain roads. Pickup services are available across Navi Mumbai including homes, offices, hotels, and railway stations. Air-conditioned vehicles ensure comfortable travel throughout the journey. Ideal for family vacations, honeymoon trips, and sightseeing tours."
},
{
name: "Cab from Navi Mumbai to Mahabaleshwar",
description: "Cab from Navi Mumbai to Mahabaleshwar provides convenient transportation for travelers planning a scenic hill station journey. Vehicles are well maintained and suitable for long-distance travel with comfortable seating and luggage capacity. Professional drivers ensure punctual pickup services and safe highway driving. Pickup is available from residential areas, business hubs, hotels, and railway stations across Navi Mumbai. Ideal for weekend getaways, tourism travel, and family trips."
},
{
name: "Taxi from Navi Mumbai to Mahabaleshwar",
description: "Taxi from Navi Mumbai to Mahabaleshwar offers reliable intercity transportation for travelers visiting the popular hill station. Vehicles provide air-conditioned interiors and comfortable seating suitable for long highway journeys. Professional drivers ensure punctual pickup and safe driving throughout the route. Ideal for tourists visiting Mahabaleshwar viewpoints, strawberry farms, and temples."
},
{
name: "Navi Mumbai Mahabaleshwar Cab Service",
description: "Navi Mumbai Mahabaleshwar cab service provides comfortable transportation for passengers traveling to the hill station. Vehicles are designed for long-distance travel and provide smooth ride quality along highways and ghat roads. Professional drivers ensure safe driving and timely pickups across Navi Mumbai."
},
{
name: "Navi Mumbai Mahabaleshwar Taxi Service",
description: "Navi Mumbai Mahabaleshwar taxi service offers dependable road transportation for travelers visiting Mahabaleshwar. Vehicles provide comfortable seating and reliable ride performance suitable for long journeys. Professional drivers ensure punctual pickup services and safe travel throughout the route."
},
{
name: "Navi Mumbai to Mahabaleshwar Cab Booking",
description: "Navi Mumbai to Mahabaleshwar cab booking allows travelers to reserve vehicles in advance for convenient hill station travel. Online and phone booking options provide quick confirmation and flexible scheduling. Vehicles provide comfortable seating and reliable performance for long-distance journeys."
},
{
name: "Navi Mumbai to Mahabaleshwar Taxi Booking Online",
description: "Navi Mumbai to Mahabaleshwar taxi booking online provides fast and convenient digital reservations for travelers planning a hill station trip. Passengers can easily schedule their ride and receive instant booking confirmation."
},
{
name: "Navi Mumbai to Mahabaleshwar Cab Price",
description: "Navi Mumbai to Mahabaleshwar cab price options provide transparent fare estimates based on vehicle category and travel distance. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size."
},
{
name: "Navi Mumbai to Mahabaleshwar Taxi Fare",
description: "Navi Mumbai to Mahabaleshwar taxi fare services offer flexible pricing depending on vehicle type and trip duration. Passengers can select economical sedans or spacious SUVs depending on their travel preferences."
},
{
name: "Navi Mumbai to Mahabaleshwar One Way Cab",
description: "Navi Mumbai to Mahabaleshwar one way cab service provides economical transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel."
},
{
name: "Navi Mumbai to Mahabaleshwar Round Trip Taxi",
description: "Navi Mumbai to Mahabaleshwar round trip taxi service provides convenient transportation for travelers planning return journeys after visiting the hill station. Vehicles remain available as per travel schedule ensuring comfortable travel in both directions."
},
{
name: "Hill Station Cab Mahabaleshwar",
description: "Hill station cab Mahabaleshwar service provides comfortable transportation for tourists visiting Mahabaleshwar and nearby hill destinations. Vehicles provide spacious seating and reliable performance suitable for mountain and highway travel."
},
{
name: "Innova Cab Navi Mumbai Mahabaleshwar",
description: "Innova cab Navi Mumbai Mahabaleshwar service provides spacious MPV transportation ideal for families and small groups traveling with luggage. Toyota Innova vehicles offer comfortable seating and smooth highway performance suitable for hill station travel."
}
],

tableData: [
["Navi Mumbai to Mahabaleshwar Cab","Navi Mumbai to Mahabaleshwar Taxi"],
["Cab from Navi Mumbai to Mahabaleshwar","Taxi from Navi Mumbai to Mahabaleshwar"],
["Navi Mumbai Mahabaleshwar Cab Service","Navi Mumbai Mahabaleshwar Taxi Service"],
["Navi Mumbai to Mahabaleshwar Cab Booking","Navi Mumbai to Mahabaleshwar Taxi Booking Online"],
["Navi Mumbai to Mahabaleshwar Cab Price","Navi Mumbai to Mahabaleshwar Taxi Fare"],
["Navi Mumbai to Mahabaleshwar One Way Cab","Navi Mumbai to Mahabaleshwar Round Trip Taxi"],
["Hill Station Cab Mahabaleshwar","Innova Cab Navi Mumbai Mahabaleshwar"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Hill Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through the scenic ghat roads from Navi Mumbai to Mahabaleshwar. They are familiar with hill station routes, curves, and weather conditions ensuring a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Navi Mumbai to Mahabaleshwar cab bookings. Customers receive clear details about per-kilometer fares, toll charges, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai to Mahabaleshwar cab service operates 24 hours a day. Whether you want to start early morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, fully air-conditioned, and regularly cleaned to ensure passengers enjoy a comfortable hill station travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and weekend travel packages from Navi Mumbai to Mahabaleshwar."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and business locations anywhere in Navi Mumbai for a smooth start to your Mahabaleshwar journey."
  },
  {
    WhyChooseheading: "Trusted Hill Station Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai to Mahabaleshwar trips thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Navi Mumbai to Mahabaleshwar?", answer: "Yes, Omshree Cabs provides reliable cab services from Navi Mumbai to Mahabaleshwar for both one-way and round-trip travel." },
  { question: "What is the distance from Navi Mumbai to Mahabaleshwar?", answer: "The distance from Navi Mumbai to Mahabaleshwar is approximately 270 km and the journey usually takes around 5 to 6 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Navi Mumbai to Mahabaleshwar?", answer: "Yes, we offer both one-way and round-trip cab services between Navi Mumbai and Mahabaleshwar." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Navi Mumbai to Mahabaleshwar cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey for sightseeing?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or scenic viewpoints." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and tourist seasons." },
  { question: "Can we visit Panchgani during the trip?", answer: "Yes, many travelers combine Mahabaleshwar travel with Panchgani sightseeing during the journey." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "We booked Omshree Cabs for our Navi Mumbai to Mahabaleshwar trip. The driver handled the ghat roads very well and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Excellent cab service for Mahabaleshwar travel. Clean vehicle, punctual driver, and smooth journey.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab offers reliable cab services from Navi Mumbai to Mahabaleshwar. Book one-way or round-trip taxis, including Innova, for hill station trips, outstation travel, and family trips.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai"
  },
  "serviceType": [
    "Navi Mumbai to Mahabaleshwar Cab",
    "Outstation Taxi Service",
    "Hill Station Cab Service",
    "Luxury Cab Service",
    "Innova Taxi Service"
  ]
};






  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai to Mahabaleshwar Cab | Omshree Cab</title>
  <meta
    name="description"
    content="Book a cab from Navi Mumbai to Mahabaleshwar with Omshree Cab. One-way or round-trip taxi options available, including Innova and luxury cabs for hill station travel."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaitomahabaleshwarcab;